import * as React from "react";
import Component from "../../AbstractComponent";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import Button from '@material-ui/core/Button';

export default class UnitDetailsReadonly extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}

	public getUnitStatusProperties = (unit: UnitInterface) => {
    let label = "";
    let color = "transparent";

		if (unit?.isRented) {
			label = this.trans("rented");
      color = "#43A047";
		}

    if (unit?.isEmpty) {
      label = this.trans("empty");
      color = "#F44336";
    }

    if (unit?.isEnding) {
      label = this.trans("ending");
      color = "#F5A623";
    }

    if (unit?.isExpiring) {
      label = this.trans("expiring");
      color = "#F5A623";
    }

    if (unit?.isInactive) {
      label = this.trans("label-deactivate");
      color = "#B2B2B2";
    }

    return {label: label, color: color};
  }

	public getReadonlyReason = (unit: UnitInterface) => {
		if (unit?.removed) {
			return this.trans("unit-readonly/removed");
		}
	}
	
  public render() {
		const unit: UnitInterface = this.props.unit;

		return (
			<div className="charge-details-readonly">
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
						<div style={{display: "flex", alignItems: "baseline"}}>
							<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
								{this.trans("label-unit")}
							</div>
							<div className="title" style={{color: this.getUnitStatusProperties(unit)?.color}}>
								{this.getUnitStatusProperties(unit)?.label}
							</div>
						</div>
					</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty">
						{`${unit?.displayName}`}
					</div>
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
					{this.trans(unit?.type?.label)}
				</div>
				<div>
					<table>
						<tr>
							<td className="align-left first-column" style={{paddingTop: this.props.changeAddressButton ? "4px" : 0}}>
								{`${this.trans("title-address")}: `}
							</td>
							<td className="align-left">
								<div className="margin-wrapper">
									<div 
										className="link-to-entity" 
										onClick={() => this.redirect(`/app/property/update/${unit?.propertyId}/`)}
									>
										{`${unit?.displayName}`}
									</div>
								</div>
							</td>
							{this.props.changeAddressButton}
						</tr>
						<tr>
							<td className="align-left first-column">
								{`${this.trans("owner")}: `}
							</td>
							<td className="align-left">
								<div className="margin-wrapper">
									<div 
										className="link-to-entity" 
										onClick={() => this.redirect(`/app/owner/update/${unit?.property?.companyId}/`)}
									>
										{`${unit?.property?.company?.displayName}`}
									</div>
								</div>
							</td>
						</tr>
						{
							unit?.squareMeters && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("unitupdate-tab/info-field/squaremeters-label")}: `}
									</td>
									<td className="align-left">
										{unit?.squareMeters}
									</td>
								</tr>
							)
						}
						{
							unit?.roomNumber && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("unitupdate-tab/info-field/rooms-label")}: `}
									</td>
									<td className="align-left">
										{unit?.roomNumber}
									</td>
								</tr>
							)
						}
						{
							unit?.bedroomNumber && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("unitupdate-tab/info-field/separatebedrooms-label")}: `}
									</td>
									<td className="align-left">
										{unit?.bedroomNumber}
									</td>
								</tr>
							)
						}
						{
							unit?.bathroomNumber && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("unitupdate-tab/info-field/bathrooms-label")}: `}
									</td>
									<td className="align-left">
										{unit?.bathroomNumber}
									</td>
								</tr>
							)
						}
					</table>
				</div>
				{
					unit?.isReadonly && this.props.mainCardPresentation &&
						<div className="readonly-reason" style={{flexDirection: "column"}}>
							<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
								<div
									className="list-label readonly"
									style={{
										marginRight: "5px",
										maxWidth: "max-content"
									}}
								>
									{unit?.isReadonly && this.trans("label-readonly")}
								</div>
								<div>{this.getReadonlyReason(unit)}</div>
							</div>
						</div>
				}
				{
					!this.props.mainCardPresentation && (
						<div style={{marginTop: "10px", display: "flex", justifyContent: "flex-start"}}>
							<Button 
								variant="outlined"
								color="primary"
								onClick={() => this.redirect(`/app/unit/update/${unit?.id}`)}
							>
								{this.trans("button-open")}
							</Button>
						</div>
					)
				}
			</div>
		);
  }
}
